<h1 mat-dialog-title>Delete step {{ getStepNumber() }}</h1>
<div mat-dialog-content>
  <p>Are you sure you want to delete this step?</p>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button (click)="onConfirmClick()">Yes</button>
</div>
